import { useState } from 'react';
import { formatIban, normaliseIban } from '@bbbk/schema';
import { api } from '../../lib/api';
import { useToast, writeWithToast } from '../common';
import { errMsg } from './utils';

// THE BANK DETAILS, ON THE DESK AT LAST (deposit-proof AC16, AC16a, AC16b).
// The keys existed since migration 0027 and nothing on the desk could set
// them, so the customer's pay sheet would have shown a blank IBAN on day one.
// Two fields and one Save, through the same generic write as the size limits;
// the IBAN is checked on the server (mod-97, the country's length) and shown
// back in groups of four, the way a bank prints it.

export function BankDetailsPanel({ accountName, iban, onSaved }: { accountName: string; iban: string; onSaved: () => void }) {
  const toast = useToast();
  const [name, setName] = useState(accountName);
  const [ibanText, setIbanText] = useState(formatIban(iban));
  const [saving, setSaving] = useState(false);
  const dirty = name.trim() !== accountName || normaliseIban(ibanText) !== normaliseIban(iban);
  const save = () => {
    setSaving(true);
    void writeWithToast(toast, {
      write: () => api('/settings', { method: 'PATCH', body: { bank_account_name: name.trim(), bank_iban: normaliseIban(ibanText) } }),
      success: 'Bank details saved',
      error: (e) => errMsg(e, 'Could not save the bank details.'),
      onSaved: () => { setIbanText(formatIban(ibanText)); onSaved(); },
    }).finally(() => setSaving(false));
  };
  return (
    <section className="fin-panel">
      <div className="fin-panel-head">
        <h3>Bank details</h3>
        <span className="panel-meta">What the customer transfers the deposit to</span>
      </div>
      <div className="pf-bank">
        <label className="field">
          <span className="field-label">Account name</span>
          <input type="text" value={name} aria-label="Account name" maxLength={80} onChange={(e) => setName(e.target.value)} />
        </label>
        <label className="field">
          <span className="field-label">IBAN</span>
          <input type="text" value={ibanText} aria-label="IBAN" placeholder="IE29 AIBK 9311 5212 3456 78" autoCapitalize="characters" spellCheck={false} onChange={(e) => setIbanText(e.target.value)} onBlur={() => setIbanText(formatIban(ibanText))} />
        </label>
        <button type="button" className="btn primary" disabled={saving || !dirty} onClick={save}>Save</button>
      </div>
      <p className="pf-note">
        The IBAN is checked when it is saved — a typo here is money sent to the wrong account. Until an IBAN is here, the customer’s pay sheet says Patricia has not added the bank details yet.
      </p>
    </section>
  );
}
